(function(Chart){
    var canvas =  document.getElementById('ordersChart');
    if (!canvas) {
        return;
    }

    var ordersChart = new Chart(document.getElementById('ordersChart').getContext('2d'), {
        type: 'horizontalBar',
        data: {
            datasets: [
                {
                    label: '1º Trimestre',
                    data: [
                        orderChartData['1'].count,
                        orderChartData['1'].base / 100,
                        orderChartData['1'].tax / 100,
                        orderChartData['1'].total / 100,
                    ],
                    backgroundColor: '#6658dd',
                },
                {
                    label: '2º Trimestre',
                    data: [
                        orderChartData['2'].count,
                        orderChartData['2'].base / 100,
                        orderChartData['2'].tax / 100,
                        orderChartData['2'].total / 100,
                    ],
                    backgroundColor: '#1abc9c',
                },
                {
                    label: '3º Trimestre',
                    data: [
                        orderChartData['3'].count,
                        orderChartData['3'].base / 100,
                        orderChartData['3'].tax / 100,
                        orderChartData['3'].total / 100,
                    ],
                    backgroundColor: '#4fc6e1',
                },
                {
                    label: '4º Trimestre',
                    data: [
                        orderChartData['4'].count,
                        orderChartData['4'].base / 100,
                        orderChartData['4'].tax / 100,
                        orderChartData['4'].total / 100,
                    ],
                    backgroundColor: '#f7b84b',
                },
            ],
            labels: ['Nº Pedidos', 'Base imponible', 'Impuestos', 'Total']
        },
        options: {
            legend: {
                labels: {
                    fontColor: "#000250",
                    fontSize: 14
                }
            },
            scales: {
                xAxes: [{
                    ticks: {
                        beginAtZero: true,
                    }
                }]
            }
        }
    });
}(Chart));